package com.macrofocus.eflux.ui.bar

import mui.material.*
import mui.material.Size
import mui.system.sx
import react.FC
import web.cssom.*

val LiquidFab = FC<FabProps> { props ->
    Tooltip {
        title = react.ReactNode(props.ariaLabel ?: "")
        placement = TooltipPlacement.right

        Fab {
            size = Size.small

            // Forward all props (onClick, color, size, etc.)
            +props

            sx {
                pointerEvents = PointerEvents.all

                opacity = number(0.66666667)

                //            backgroundColor = Color("#ffffffaa") // glass-like
                backdropFilter = "blur(10px)".unsafeCast<BackdropFilter>()
                boxShadow = BoxShadow(0.px, 4.px, 15.px, Color("#00000033"))
                transition = "transform 0.2s ease, box-shadow 0.3s ease".unsafeCast<Transition>()

                "&:hover" {
                    transform = scale(1.1)
                    boxShadow = BoxShadow(0.px, 8.px, 25.px, Color("#00000044"))
                    zIndex = "3000".unsafeCast<ZIndex>()
                }
                "&:active" {
                    transform = scale(0.95)
                    zIndex = "2000".unsafeCast<ZIndex>()
                }
            }

            // Children (icon inside Fab) are already forwarded by `+props` above;
            // adding them again via `+props.children` triggers "Both `children` source options used".
        }
    }
}